/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';


import { AccessTokenError } from '../model/accessTokenError';
import { ErrorMessage } from '../model/errorMessage';
import { WebhookEventResponseInfo } from '../model/webhookEventResponseInfo';
import { WebhookResponseInfo } from '../model/webhookResponseInfo';
import { WebhookSystemResponseInfo } from '../model/webhookSystemResponseInfo';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { Observable } from 'rxjs';


@Injectable()
export class WebhookMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * WebhookMgr_WebhookEventRetrieve, Retrieve all Webhook Event
     * Retrieve all Webhook Event
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhookMgrV1WebhookEventGet(observe?: 'body', reportProgress?: boolean): Observable<WebhookEventResponseInfo>;
    public webhookMgrV1WebhookEventGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookEventResponseInfo>>;
    public webhookMgrV1WebhookEventGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookEventResponseInfo>>;
    public webhookMgrV1WebhookEventGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<WebhookEventResponseInfo>(`${this.basePath}/WebhookMgr/V1/WebhookEvent`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * WebhookMgr_WebhookRetrieve, Retrieve Webhook based on Id
     * Retrieve Webhook based on Id
     * @param Id Enter the WebhookId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhookMgrV1WebhookIdPost(Id: number, observe?: 'body', reportProgress?: boolean): Observable<WebhookResponseInfo>;
    public webhookMgrV1WebhookIdPost(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookResponseInfo>>;
    public webhookMgrV1WebhookIdPost(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookResponseInfo>>;
    public webhookMgrV1WebhookIdPost(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling webhookMgrV1WebhookIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<WebhookResponseInfo>(`${this.basePath}/WebhookMgr/V1/Webhook/${encodeURIComponent(String(Id))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * WebhookMgr_WebhookSystem, Retrieve all Webhook Supported Systems
     * Retrieve all Webhook Supported Systems
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public webhookMgrV1WebhookSystemGet(observe?: 'body', reportProgress?: boolean): Observable<WebhookSystemResponseInfo>;
    public webhookMgrV1WebhookSystemGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookSystemResponseInfo>>;
    public webhookMgrV1WebhookSystemGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookSystemResponseInfo>>;
    public webhookMgrV1WebhookSystemGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<WebhookSystemResponseInfo>(`${this.basePath}/WebhookMgr/V1/WebhookSystem`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
